import axios from 'axios';
import type { User, UserLogin, Token } from '@types';
import { getToken, saveToken, removeToken } from '@/utils/storage';

const API_URL = import.meta.env.VITE_API_URL;

// Axios インスタンス作成
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// リクエストインターセプター（トークンを自動付与）
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ログイン
export const login = async (credentials: UserLogin): Promise<Token> => {
  const response = await api.post<Token>('/auth/login', credentials);
  saveToken(response.data.access_token);
  return response.data;
};

// 現在のユーザー情報取得
export const getCurrentUser = async (): Promise<User> => {
  const response = await api.get<User>('/auth/me');
  return response.data;
};

// ログアウト
export const logout = (): void => {
  removeToken();
};

export default api;
